import { useContext } from "react";
import { NavLink } from "../models/global/Types";
import { LanguageContext } from "../globals/LanguageContext";
import {
  Bank,
  Briefcase,
  BriefcaseIcon,
  ChartBar,
  ChartDonut,
  ChatsCircle,
  ChatsCircleIcon,
  Folder,
  FolderIcon,
  Gear,
  GearIcon,
  Invoice,
  InvoiceIcon,
  Stack,
  StackIcon,
} from "@phosphor-icons/react";

export const useNavbar = () => {
  const { dictionary } = useContext(LanguageContext);

  const iconSizeNavbar = 28;

  const links: NavLink[] = [
    {
      title: dictionary.pages.dashboard.title,
      path: "/",
      icon: <ChartBar size={iconSizeNavbar} />,
    },
    // {
    //   title: dictionary.pages.calandar.title,
    //   path: "/agenda",
    //   icon: <CalendarBlank size={iconSizeNavbar} />,
    // },
    {
      title: dictionary.pages.projects.title,
      path: "/projects",
      icon: <BriefcaseIcon size={iconSizeNavbar} />,
    },
    {
      title: dictionary.pages.materials.title,
      path: "/materials",
      icon: <StackIcon size={iconSizeNavbar} />,
    },
    {
      title: dictionary.pages.quotes.title,
      path: "/quotes",
      icon: <InvoiceIcon size={iconSizeNavbar} />,
    },
    {
      title: dictionary.pages.invoices.title,
      path: "/invoices",
      icon: <InvoiceIcon size={iconSizeNavbar} />,
    },
    {
      title: dictionary.pages.files.title,
      path: "/files",
      icon: <FolderIcon size={iconSizeNavbar} />,
    },
    // {
    //   title: dictionary.pages.statistics.title,
    //   path: "/statistics",
    //   icon: <ChartDonut size={iconSizeNavbar} />,
    // },
    // {
    //   title: dictionary.pages.finances.title,
    //   path: "/finances",
    //   icon: <Bank size={iconSizeNavbar} />,
    // },
    {
      title: dictionary.pages.chats.title,
      path: "/chats",
      icon: <ChatsCircleIcon size={iconSizeNavbar} />,
    },
    {
      title: dictionary.pages.cms.title,
      path: "/cms/achievements",
      icon: <GearIcon size={iconSizeNavbar} />,
    },
  ];

  return { links };
};
